import { render, staticRenderFns } from "./MultipleSelectQuizQuestion.vue?vue&type=template&id=65d12d0a"
import script from "./MultipleSelectQuizQuestion.vue?vue&type=script&lang=js"
export * from "./MultipleSelectQuizQuestion.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelectQuizQuestion.vue?vue&type=style&index=0&id=65d12d0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports